<template>
  <v-expansion-panels
    v-model="expandedPanels"
    class="other-countries-of-doctor-work justify-start"
    :class="{
      'other-countries-of-doctor-work--desktop': !isMobile,
      'other-countries-of-doctor-work--mobile': isMobile,
    }"
    accordion
    flat
    multiple
    tile
  >
    <v-expansion-panel
      class="other-countries-of-doctor-work__expansion-panel"
      :class="{
        'other-countries-of-doctor-work__expansion-panel--desktop': !isMobile,
        'other-countries-of-doctor-work__expansion-panel--mobile': isMobile,
      }"
    >
      <v-expansion-panel-header
        class="other-countries-of-doctor-work__panel-header"
        expand-icon="ui-icon-arrow-down"
      >
        <div class="d-flex align-center">
          <span class="ui-icon-globe icon-secondary--text ui-icon-fz-medium mr-4" />
          <div class="text-body-1 text--text mr-auto">
            {{ t('Принимает в других странах', options) }}
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <a
          v-for="({ name, link }, index) in otherCountriesOfWork"
          :key="index"
          v-ripple
          class="d-flex align-center cursor-pointer text-decoration-none py-3 pl-9"
          :href="link"
        >
          <div class="text-body-1 text--text mr-auto">
            {{ name }}
          </div>
          <span class="ui-icon-arrow-right icon-secondary--text ml-4" />
        </a>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import useExternalDataStore from 'www/vue_components/common/DoctorPageLpuList/stores/useExternalDataStore'

const externalData = useExternalDataStore()
const { isMobile, otherCountriesOfWork } = storeToRefs(externalData)

const { t, language } = I18NextVue
const options = { ns: language }

const expandedPanels = ref(isMobile.value ? [] : [0])
</script>

<style lang="scss">
.other-countries-of-doctor-work {
  margin-top: 8px;

  &__expansion-panel {
    box-shadow: initial;
  }

  &--desktop {
    padding: 0 24px 16px;
    max-width: 384px;

    & > .v-expansion-panel::before {
      box-shadow: initial;
    }
  }

  &--mobile {
    padding: 0 8px 8px;
  }

  &__panel-header {
    padding: 8px 0 !important;
    min-height: 40px !important;
  }

  & .v-expansion-panel-content__wrap {
    padding: 0;
  }
}
</style>
